import { Card } from 'antd';
import React, { FC, memo, useCallback } from 'react';
import { AppLogo } from '../../../app/appState';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { useAppDispatch } from 'app/config/storeConfig/hooks';
import { LangSwitcher } from 'features/LangSwitcher';
import { authFormActions } from '../model/slice/authFormSlice';
import { ReactComponent as ArrowRight } from 'shared/assets/icons/ArrowRight.svg';
import { ForgotPasswordSteps } from './ForgotPasswordSteps';

export const ForgotPasswordForm: FC = memo(() => {
  const { t } = useAppTranslation(['login-page', 'common']);

  const dispatch = useAppDispatch();

  const openAuthScreen = useCallback((): void => {
    dispatch(authFormActions.changeMode('login'));
  }, [dispatch]);

  return (
    <Card
      className="w-[370px] pt-[24px] tablet:w-[450px]"
      title={
        <div className="flex items-center p-3 justify-center">
          <AppLogo width={180} height="100%" />
          <div className="absolute top-0 right-0">
            <LangSwitcher />
          </div>
        </div>
      }
    >
      <div className="flex items-center text-sm text-accent cursor-pointer mb-6" onClick={openAuthScreen}>
        <ArrowRight className="[&>path]:stroke-accent rotate-180 mr-2 w-5" />
        {t('Go back')}
      </div>
      <ForgotPasswordSteps />
    </Card>
  );
});
